import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { IconProps } from "../../../custom";
import { useStaticQuery, graphql } from "gatsby";

export const Icons = [
  "find",
  "personalloan",
  "refinance",
  "payment",
  "thumbsup",
  "employee",
  "home",
  "wallet",
  "thumbupsimple",
  "clap",
  "money",
  "check",
  "thumbsupglare",
  "devices",
];

const Icon = ({ icon, size }: IconProps) => {
  const data = useStaticQuery(graphql`
    query IconQuery {
      find: file(relativePath: { eq: "icons/FindABranchIcon.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      personalloan: file(relativePath: { eq: "icons/PersonalLoanIcon.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      refinance: file(relativePath: { eq: "icons/RefinanceIcon.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      payment: file(relativePath: { eq: "icons/MakeAPaymentIcon.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      thumbup: file(relativePath: { eq: "icons/aboutus_thumbup.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      employee: file(relativePath: { eq: "icons/aboutus_employee.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      home: file(relativePath: { eq: "icons/aboutus_homes.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      wallet: file(relativePath: { eq: "icons/wallet.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      thumbupsimple: file(relativePath: { eq: "icons/thumbsup.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      money: file(relativePath: { eq: "icons/money.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      clap: file(relativePath: { eq: "icons/clapping.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      check: file(relativePath: { eq: "icons/check.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      thumbsupglare: file(relativePath: { eq: "icons/thumbsupglare.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
      devices: file(relativePath: { eq: "icons/devices.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200, placeholder: NONE, formats: [WEBP, AVIF])
        }
      }
    }
  `);

  return (
    <GatsbyImage
      sx={{
        width: size ? size : 100,
        objectFit: "contain",
      }}
      image={data[icon].childImageSharp.gatsbyImageData}
      alt="icon"
    />
  );
};

export default Icon;
